import { render, staticRenderFns } from "./TicketDetailsSupervisor.vue?vue&type=template&id=6cf1db84&scoped=true&"
import script from "./TicketDetailsSupervisor.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsSupervisor.vue?vue&type=style&index=0&id=6cf1db84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1db84",
  null
  
)

export default component.exports